import { auth } from "../firebase";

export default async function getAuthHeaders(extraHeaders: Record<string, string> = {}): Promise<Record<string, string>> {
  const user = auth.currentUser;
  if (!user) {
    return extraHeaders;
  }

  const idToken = await user.getIdToken();
  return {
    ...extraHeaders,
    Authorization: `Bearer ${idToken}`,
  };
}
